import { useQuery } from "@tanstack/react-query";
import { ScenarioDeploy } from "@/model";
import deployRepository from "@/repository/deployRepository";


const getData = async (scenarioId: string, deployId: string) => {
    const response = await deployRepository.read(scenarioId, deployId);
    return response.data;
};

export const useScenarioDeploy = (scenarioId: string, deployId: string) => {
    return useQuery<ScenarioDeploy>({
        queryKey: ['scenario-deploy', scenarioId, deployId],
        queryFn: () => getData(scenarioId, deployId),
        enabled: !!scenarioId && !!deployId
    });
};
